import { useContext } from "react";
import { GraphContext } from "./data";
import { DataSet, DataSourceList, groupKeysList } from "./model";

export const CrPanel = (props: { side: "left" | "right"; }) => {
  const { sharedData, setSharedData, groupData, secondGroupData, setGroupIndex, showUnknown, setShowUnknown, searchText } = useContext(GraphContext);

  const PanelLeft = (props: { dataGroup: DataSet[] }) => {
    const onClick = (data: DataSet) => {
      setSharedData({
        source: sharedData.source,
        subType: sharedData.subType === data.name ? "" : data.name,
        leftGroupKey: sharedData.leftGroupKey,
        leftSelectedKey: searchText || sharedData.leftSelectedKey === data.name ? undefined : data.name,
        rightSelectedKey: undefined,
      });
    };
    const onUnknownChange = (e: React.ChangeEvent<HTMLInputElement>, data: DataSet) => {
      e.stopPropagation();
      e.preventDefault();
      setShowUnknown(e.target.checked);
    };
    return <div className="panel-box-full">
      {props.dataGroup.length > 0 ? props.dataGroup
        .map((data: DataSet, index: number) => (
          <div
            key={index}
            className={
              "color-bar" + (!sharedData.leftSelectedKey
                ? ""
                : sharedData.leftSelectedKey === data.name
                  ? " active"
                  : " dark")
            }
            onClick={() => {
              onClick(data);
            }}
          >
            <span className="item" style={{ backgroundColor: sharedData.leftSelectedKey ? '#797979' : data.color }}></span>
            <span className="name">{data.name}{data.name === 'Unknown' ? <input type='checkbox' checked={showUnknown} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} onChange={(e) => onUnknownChange(e, data)} /> : ''}</span>
            <span className="count">({data.count})</span>
            {sharedData.leftGroupKey === 'Pfam' && <span className="link"><a href={`https://www.ebi.ac.uk/interpro/entry/pfam/${data.name.split(';')[0]}`} target="_blank">🔗</a></span>}
            {sharedData.leftGroupKey?.startsWith('GO-') && <span className="link"><a href={`https://amigo.geneontology.org/amigo/term/${data.name.split(';')[0]}`} target="_blank">🔗</a></span>}
          </div>
        )) : <div className="no-data">Loading</div>}
    </div >;
  }

  const PanelRight = (props: { dataGroup: DataSet[]; height: string }) => {
    const restList = groupKeysList.filter((key) => key !== sharedData.leftGroupKey);
    let rightGroupKey = sharedData.rightGroupKey || restList[0];
    if (!restList.includes(rightGroupKey)) {
      rightGroupKey = restList[0];
    }

    const onClick = (data: DataSet) => {
      setSharedData({
        source: sharedData.source,
        subType: sharedData.subType === data.name ? "" : data.name,
        leftGroupKey: sharedData.leftGroupKey,
        leftSelectedKey: sharedData.leftSelectedKey,
        rightGroupKey: sharedData.rightGroupKey,
        rightSelectedKey: sharedData.rightSelectedKey === data.name ? undefined : data.name,
      });
    };
    return <div className="panel-box-half" style={{ height: props.height }}>
      <div className="title">
        Select your interested: <select className="group-select" value={rightGroupKey} onChange={(e) => onGroupKeyChange(e, 'right')}>
          {restList.map((key) => <option key={key} value={key}>{key}</option>)}
        </select>
      </div>
      <div className="panel-box-list">
        {props.dataGroup.length > 0 ? props.dataGroup
          .map((data: DataSet, index: number) => (
            <div
              key={index}
              className={
                "color-bar" + (!sharedData.rightSelectedKey
                  ? ""
                  : sharedData.rightSelectedKey === data.name
                    ? " active"
                    : " dark")
              }
              onClick={() => {
                onClick(data);
              }}
            >
              <span className="item" style={{ backgroundColor: data.color }}></span>
              <span className="name">{data.name}</span>
              <span className="count">({data.count})</span>
            </div>
          )) : <div className="no-data">Loading</div>}
      </div>
    </div >;
  }

  const onDataSourceChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setGroupIndex(parseInt(e.target.value));
  }
  const onGroupKeyChange = (e: React.ChangeEvent<HTMLSelectElement>, side: "left" | "right") => {
    setSharedData({
      source: sharedData.source,
      subType: sharedData.subType,
      leftGroupKey: side === "left" ? e.target.value : sharedData.leftGroupKey,
      leftSelectedKey: side === "right" ? sharedData.leftSelectedKey : undefined,
      rightGroupKey: side === "right" ? e.target.value : undefined, // when select left group key, right group key should be reset
      rightSelectedKey: undefined,
    });
  };
  if (props.side === "right") {
    const showTop = sharedData.leftGroupKey && sharedData.leftSelectedKey && secondGroupData.length && !searchText;
    if (!showTop) {
      return null;
    }
    return (
      <div className="panel-right color-panel">
        <PanelRight dataGroup={secondGroupData} height={'100%'} />
      </div>
    );
  }

  let leftGroupKey = sharedData.leftGroupKey || groupKeysList[0];
  return (
    <div className="panel-left color-panel">
      <div className="title">
        Data Source: <select className="group-select" onChange={(e) => onDataSourceChange(e)}>
          <option key="-" value="-"> - </option>
          {DataSourceList.map((key) => <option key={key.name} value={key.groupIndex}>{key.name}</option>)}
        </select>
      </div>
      <div className="title">
        Select your interested: <select className="group-select" value={leftGroupKey} onChange={(e) => onGroupKeyChange(e, 'left')}>
          {groupKeysList.map((key) => <option key={key} value={key}>{key}</option>)}
        </select>
      </div>
      <PanelLeft dataGroup={groupData[leftGroupKey]?.dataList || []} />
    </div>
  );
};
